import styled from '@emotion/styled'
import { DivProps } from 'commons/types/htmlElements'
import { theme as newTheme } from 'styles/theme/hav-theme'

export type PaddingBreakpointTypes = 'lg' | 'md' | 'sm' | 'xl'

interface MultiGridItemStyledProps extends DivProps {
  image: boolean
  sideimage: boolean
  height: string
  width: string
  paddingBreakpoint: PaddingBreakpointTypes
}
interface SingleGridItemStyledProps extends DivProps {
  height: string
  paddingBreakpoint: PaddingBreakpointTypes
}

export const GridRowItemsStyled = styled('div')`
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: ${newTheme.breakpoints.md}px) {
    flex-direction: column;
    align-items: center;
  }
`

export const MultiGridItemStyled = styled.div<MultiGridItemStyledProps>`
  display: flex;
  flex-direction: row;
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  background-color: ${newTheme.colors.neutral.white};
  text-shadow: ${({ image }) => (image ? newTheme.effects.boxShadow['rule-01'] : 'none')};
  box-shadow: ${({ image }) => (!image ? newTheme.effects.boxShadow['rule-01'] : 'none')};
  border-radius: ${newTheme.shapes.borderRadius.md};
  margin-right: ${newTheme.spacing.xm};

  @media only screen and (max-width: ${newTheme.breakpoints.md}px) {
    width: 100%;
    margin: ${newTheme.spacing.xm} 0 0 0;
  }

  padding: ${({ image, sideimage }) =>
    !image && !sideimage
      ? `
        ${newTheme.spacing.xm}
        ${newTheme.spacing.xm}
        ${newTheme.spacing.xm}
        ${newTheme.spacing.xm};`
      : 0};

  ${({ paddingBreakpoint }) => newTheme.breakpoints[paddingBreakpoint]} {
    padding: ${({ image }) =>
      !image
        ? `
          ${newTheme.spacing.sm}
          ${newTheme.spacing.sm}
          ${newTheme.spacing.sm}
          ${newTheme.spacing.sm};`
        : 0};
  }

  :hover {
    cursor: ${({ image }) => (image ? 'pointer' : 'auto')};
  }

  :last-of-type {
    margin-right: 0;
  }

  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    margin-right: 0;
    width: 100%;
    flex-direction: column;
    :last-of-type {
      margin-bottom: 0;
    }
  }
`

export const SingleGridItemStyled = styled.div<SingleGridItemStyledProps>`
  min-width: 100%;
  max-width: calc(100vw - 40px);
  height: ${({ height }) => height};
  background-color: ${newTheme.colors.neutral.white};
  box-shadow: ${newTheme.effects.boxShadow['rule-01']};
  border-radius: ${newTheme.shapes.borderRadius.md};
  display: flex;
  flex-direction: row;

  padding: ${newTheme.spacing.xm};

  ${({ paddingBreakpoint }) => newTheme.breakpoints[paddingBreakpoint]} {
    flex-direction: column;
    padding: ${newTheme.spacing.sm};
  }

  @media only screen and (max-width: ${newTheme.breakpoints.sm}px) {
    flex-direction: column;
  }
`
